import * as React from "react"
import * as styles from "./styles.module.scss"

const OurGoal: React.FC = () => {
  return (
    <section className={styles.textBlock}>
      <div className={styles.pagePadding}>
        <div className={styles.message}>
          <div className={styles.header}>
            <h2 className={styles.heading}>Our goal</h2>
          </div>
          <div className={styles.description}>
            <p className={styles.paragraph}>
              We believe home finance should be better for all Americans. It
              should be fast, transparent, and low-cost. Better’s mission is to
              make that happen.
            </p>
            <p className={styles.paragraph}>
              This is a huge, important part of our economy. Housing overall is
              a $23 trillion business, and mortgages account for $13 trillion.
              Yet home finance operates in the same way it has for decades —
              through opaque systems and expensive intermediaries whose
              interests are misaligned with consumers’.
            </p>
            <p className={styles.paragraph}>
              That’s why Better is re-engineering the home finance process from
              the ground up. We’re using technology to make it faster and more
              efficient, and humans to help make it friendly and enjoyable.
            </p>
            <p className={styles.paragraph}>
              Please join us in making home finance better.
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}

export default OurGoal
